import type { LexicalText } from "@/schema/lexical-text"
import { $getRoot, $getSelection, $isRangeSelection, $parseSerializedNode } from "lexical"

import { htmlToNodes } from "@/components/lexical/serializer"

// Call inside an editor update so slash replacement and insertion share one undo step.
export function $insertEmailSnippet(body: LexicalText) {
  const serialized = body.nodes ?? htmlToNodes(body.html ?? "")
  if (!serialized) return
  const selection = $getSelection() ?? $getRoot().selectEnd()
  if ($isRangeSelection(selection)) {
    selection.insertNodes(serialized.root.children.map((node) => $parseSerializedNode(node)))
  }
}
